// Nghe log cua mot lan chay qua WebSocket.
//
// Backend gui "snapshot" truoc (toan bo log da co) roi moi gui tung dong, nen
// mo muon van khong hong dong nao. Neu WebSocket chet giua chung thi tu doi
// sang hoi lai bang HTTP moi 2 giay - tha cham con hon mat log.

import { useCallback, useEffect, useRef, useState } from "react";
import { api, moStreamLog } from "../api";
import type { LogLine, RunMeta } from "../types";

const DA_XONG = new Set(["success", "failed", "cancelled", "error"]);

export function useRunStream(runId: string | null) {
  const [run, setRun] = useState<RunMeta | null>(null);
  const [log, setLog] = useState<LogLine[]>([]);
  const [noi, setNoi] = useState<"dang-noi" | "mat-ket-noi" | "xong" | "cho">("cho");
  const wsRef = useRef<WebSocket | null>(null);
  const pollRef = useRef<number | null>(null);

  const dung = useCallback(() => {
    wsRef.current?.close();
    wsRef.current = null;
    if (pollRef.current) {
      window.clearInterval(pollRef.current);
      pollRef.current = null;
    }
  }, []);

  useEffect(() => {
    dung();
    setRun(null);
    setLog([]);
    if (!runId) {
      setNoi("cho");
      return;
    }

    let huy = false;
    setNoi("dang-noi");

    const ws = moStreamLog(runId);
    wsRef.current = ws;

    ws.onmessage = (ev) => {
      if (huy) return;
      const msg = JSON.parse(ev.data as string);
      switch (msg.type) {
        case "snapshot":
          setRun(msg.run);
          setLog(msg.log);
          break;
        case "line":
          setLog((cu) => [...cu, msg.line]);
          break;
        case "status":
          setRun(msg.run);
          break;
        case "end":
          setNoi("xong");
          break;
      }
    };

    ws.onerror = () => {
      if (!huy) setNoi("mat-ket-noi");
    };

    ws.onclose = () => {
      if (huy) return;
      // Chot lai trang thai cuoi: WebSocket co the dong truoc khi kip bao.
      api
        .run(runId)
        .then((r) => {
          if (huy) return;
          setRun(r.run);
          setLog(r.log);
          setNoi(DA_XONG.has(r.run.status) ? "xong" : "mat-ket-noi");
          if (!DA_XONG.has(r.run.status) && !pollRef.current) {
            pollRef.current = window.setInterval(async () => {
              const lai = await api.run(runId).catch(() => null);
              if (!lai || huy) return;
              setRun(lai.run);
              setLog(lai.log);
              if (DA_XONG.has(lai.run.status)) {
                setNoi("xong");
                if (pollRef.current) window.clearInterval(pollRef.current);
                pollRef.current = null;
              }
            }, 2000);
          }
        })
        .catch(() => !huy && setNoi("mat-ket-noi"));
    };

    return () => {
      huy = true;
      dung();
    };
  }, [runId, dung]);

  const dangChay = run ? !DA_XONG.has(run.status) : false;
  return { run, log, noi, dangChay };
}
